'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from 'react';
import { useProductCardMobileAccordionPageAction } from './hooks';
export function AccordionAnalyticsTracker(t0) {
  const $ = _c(8);
  const {
    detailsId,
    analyticsActionName,
    actionSection
  } = t0;
  const firePageAction = useProductCardMobileAccordionPageAction();
  let t1;
  if ($[0] !== actionSection || $[1] !== analyticsActionName || $[2] !== firePageAction) {
    t1 = e => {
      const details = e.currentTarget as HTMLDetailsElement;
      const actionType = details.open ? "open" : "close";
      firePageAction(actionType, analyticsActionName, actionSection);
    };
    $[0] = actionSection;
    $[1] = analyticsActionName;
    $[2] = firePageAction;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleToggle = t1;
  let t2;
  let t3;
  if ($[4] !== detailsId || $[5] !== handleToggle) {
    t2 = () => {
      const details_0 = document.getElementById(detailsId);
      if (!details_0) {
        return;
      }
      details_0.addEventListener("toggle", handleToggle);
      return () => details_0.removeEventListener("toggle", handleToggle);
    };
    t3 = [detailsId, handleToggle];
    $[4] = detailsId;
    $[5] = handleToggle;
    $[6] = t2;
    $[7] = t3;
  } else {
    t2 = $[6];
    t3 = $[7];
  }
  useEffect(t2, t3);
  return null;
}